var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBusinessVehicle40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BusinessVehicle64-Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pictogram",
    transform: "translate(6.125000, 11.750000)",
    fillRule: "nonzero",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Window",
    fill: "#FFFFFF",
    points: "17.3906636 4.25 24.1305942 4.25 27.875 9.96953867 27.875 14.2448938 15.875 14.25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Body",
    fill: "#FFCC00",
    x: 16.875,
    y: 10.25,
    width: 11,
    height: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Rear",
    fill: "#FFFFFF",
    points: "7.17505033 15.25 16.875 15.2499996 16.875 0.25 0.875 0.25 0.875 4.24503069 0.875 15.25 6.69571041 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.375,18.25 C20.995,18.25 19.875,17.13 19.875,15.75 C19.875,14.3683334 20.995,13.25 22.375,13.25 C23.7566666,13.25 24.875,14.3683334 24.875,15.75 C24.875,17.13 23.7566666,18.25 22.375,18.25 Z",
    id: "FrontWheel",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.875,15.75 C9.875,17.13 8.75666665,18.25 7.375,18.25 C5.995,18.25 4.875,17.13 4.875,15.75 C4.875,14.3683334 5.995,13.25 7.375,13.25 C8.75666665,13.25 9.875,14.3683334 9.875,15.75 L9.875,15.75 Z",
    id: "BackWheel",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBusinessVehicle40);
export default __webpack_public_path__ + "static/media/pictogramBusinessVehicle40.3b22314ef143be927091daac4b946e3f.svg";
export { ForwardRef as ReactComponent };